import { ConstantItems } from "@constants/shared";

export class ExchangeService {
  private exchangeRates: {
    ratesToMur: { [currency: string]: number }[],
    ratesFromMur: { [currency: string]: number }[]
    otherRates: { [currencyPair: string]: number }[]
  };

  /** @ngInject */
  constructor(private $http: angular.IHttpService, private config: ConstantItems, private notifyjs: any) {
    if (!this.exchangeRates) {
      this.getExchangeRates();
    }
  }

  private getExchangeRates() {
    this.$http.get(`${this.config.exchangeUrl}/latest`)
      .then(res => this.exchangeRates = res.data as any)
      .catch(err => {
        this.notifyjs('Failed to retrieve exchange rates. Please ensure you are still logged in.')
        console.log(err)
      });
  }

  public convertToMUR(value: number, fromCurrency: string) {
    if (!this.exchangeRates) {
      this.getExchangeRates();
      return 0;
    }

    return value * this.exchangeRates.ratesToMur[fromCurrency];
  }

  public convertFromMUR(value: number, toCurrency: string) {
    if (!this.exchangeRates) {
      this.getExchangeRates();
      return 0;
    }

    return value * this.exchangeRates.ratesFromMur[toCurrency];
  }

  public convertCurrency(value: number, fromCurrency: string, toCurrency: string) {
    if (fromCurrency === 'MUR') {
      return this.convertFromMUR(value, toCurrency)
    } else if (toCurrency === 'MUR') {
      return this.convertToMUR(value, fromCurrency);
    } else {
      return value * this.exchangeRates.otherRates[`${fromCurrency}${toCurrency}`];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/exchange.service.ts